import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
function getCircularProgressUtilityClass(slot) {
  return generateUtilityClass("MuiCircularProgress", slot);
}
generateUtilityClasses("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
export {
  getCircularProgressUtilityClass
};
//# sourceMappingURL=circularProgressClasses.es.js.map
